import { createBrowserRouter, RouterProvider, Outlet, Navigate } from 'react-router'

import Sidebar from '@/components/Sidebar'
import ErrorFallback from '@/components/ErrorFallback'
import Alert from '@/pages/Alert'
import Dashboard from '@/pages/Dashboard'
import Profile from '@/pages/Profile'
import Watchdog from '@/pages/Watchdog'
import Settings from '@/pages/Settings'
import Notifications from '@/pages/Notifications'
import Organization from '@/pages/Organization'
import MemberSettings from '@/pages/MemberSettings'
import IndividualSettings from '@/pages/IndividualSettings'

import settingsTabs from './tabsSystems/settingsTabs'
import watchdogTabs from './tabsSystems/watchdogTabs'
import organizationTabs from './tabsSystems/organizationTabs'
import organizationMemberTabs from './tabsSystems/organizationMemberTabs'
import organizationIndividualTabs from './tabsSystems/organizationIndividualTabs'
import ProtectedRoute from './protectedRoute'
import MyAlerts from '@/pages/MyAlerts'

const LoggedInLayout = () => (
  <main className='container'>
    <Sidebar />
    <Outlet />
  </main>
)

export const loggedInRouter = createBrowserRouter([
  {
    element: <LoggedInLayout />,
    ErrorBoundary: ErrorFallback,
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'my-alerts',
        children: [
          {
            index: true,
            element: <Navigate replace to={watchdogTabs[0].url} />
          },
          {
            path: ':status',
            element: (
              <ProtectedRoute
                allowedRoles={['ADMIN', 'DELEGATE']}
                element={<MyAlerts />}
              />
            )
          },
          {
            path: '*',
            element: <Navigate replace to='/' />
          }
        ]
      },
      {
        path: 'organization',
        children: [
          {
            index: true,
            element: <Navigate replace to={organizationTabs[0].url} />
          },
          ...organizationTabs
            .filter(({ disabled }) => !disabled)
            .map(({ url }) => ({
              path: url,
              element: (
                <ProtectedRoute
                  allowedRoles={['ADMIN']}
                  element={<Organization />}
                />
              )
            })),
          {
            path: '*',
            element: <Navigate replace to='/' />
          }
        ]
      },
      {
        path: 'member/:id',
        children: [
          {
            index: true,
            element: <Navigate replace to={organizationMemberTabs[0].url} />
          },
          ...organizationMemberTabs
            .filter(({ disabled }) => !disabled)
            .map(({ url }) => ({
              path: url,
              element: (
                <ProtectedRoute
                  allowedRoles={['ADMIN']}
                  element={<MemberSettings />}
                />
              )
            })),
          {
            path: '*',
            element: <Navigate replace to='/' />
          }
        ]
      },
      {
        path: 'individual/:id',
        children: [
          {
            index: true,
            element: <Navigate replace to={organizationIndividualTabs[0].url} />
          },
          ...organizationIndividualTabs
            .filter(({ disabled }) => !disabled)
            .map(({ url }) => ({
              path: url,
              element: (
                <ProtectedRoute
                  allowedRoles={['ADMIN']}
                  element={<IndividualSettings />}
                />
              )
            })),
          {
            path: '*',
            element: <Navigate replace to='/' />
          }
        ]
      },
      {
        path: 'watchdog/:id',
        children: [
          {
            index: true,
            element: <Navigate replace to={watchdogTabs[0].url} />
          },
          {
            path: ':status',
            element: <Watchdog />
          },
          {
            path: '*',
            element: <Navigate replace to='/' />
          }
        ]
      },
      {
        path: 'profile/:id',
        element: <Profile />
      },
      {
        path: 'notifications',
        element: <Notifications />
      },
      {
        path: 'settings',
        children: [
          {
            index: true,
            element: <Navigate replace to={settingsTabs[0].url} />
          },
          ...settingsTabs
            .filter(({ disabled }) => !disabled)
            .map(({ url }) => ({
              path: url,
              element: <Settings />
            })),
          {
            path: '*',
            element: <Navigate replace to='/' />
          }
        ]
      },
      {
        path: 'alert/:id',
        element: <Alert />
      },
      {
        path: '*',
        element: <Navigate replace to='/' />
      }
    ]
  }
])

const LoggedIn = () => <RouterProvider router={loggedInRouter} />

export default LoggedIn
